export const generateProperNameFromUnderscoreValue = (value: string): string => {
	// Split the value into words
	const words: string[] = value.split("_");
	// Capitalize the first letter of each word and join them back together
	const properName: string = words.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
	return properName;
};
